import React from 'react';
import DebitNoteForm from './DebitNoteForm';

const NewDebitNotePage = () => {
    return <DebitNoteForm formType="create" currentId={null} />;
};
export default NewDebitNotePage;